// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3DL7q","story-video":"_2du_H","video-text":"_1qwem","summary":"_3Atpa"};